class Accordion extends HTMLDivElement {
  constructor() {
    super();
    this.el = this.querySelector('details');
    this.summary = this.el.querySelector('summary');
    this.content = this.el.querySelector('.footer-block__details-content');
    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;
    this.duration = 400;

    const accordion = new AccordionGlobals();
    this.summary.addEventListener('click', (e) => accordion.onClick(e, this));
  }
}

function addCustomElement() {
  customElements.define('footer-accordion', Accordion, { extends: 'div'});
}

function clickToCopy(event, element) {
  event.preventDefault();
  const emailElem = element.getAttribute('data-email-url');
  const email = emailElem.replace('mailto:', '');
  const copiedElem = element.querySelector('.tooltip__copied');
  const copyElem = element.querySelector('.tooltip__copy');
  navigator.clipboard.writeText(email).then(() => {
    copiedElem.classList.remove('hidden');
    copiedElem.classList.add('fadeIn');
    copyElem.classList.add('hidden');
    setTimeout(() => {
      copyElem.classList.remove('hidden');
      copiedElem.classList.add('hidden');
      copiedElem.classList.remove('fadeIn');
    }, 2000);
  })
}

addEventListener('DOMContentLoaded', () => addCustomElement());

const emailCopy = document.querySelector('.js-click-to-copy');
const emailCopyMobile = document.querySelector('.js-click-to-copy-mobile');

if (emailCopy) {
  const clickToCopySpan = document.createElement('div');
  const html = '<span class="tooltip__copied hidden">Copied</span><span class="tooltip__copy">Click to copy</span>';
  clickToCopySpan.classList.add('tooltip__wrapper');
  clickToCopySpan.innerHTML = html;
  emailCopy?.appendChild(clickToCopySpan);
  emailCopy?.addEventListener('click', (e) => clickToCopy(e, emailCopy));
}

if (emailCopyMobile) {
  const clickToCopySpan = document.createElement('div');
  const html = '<span class="tooltip__copied hidden">Copied</span><span class="tooltip__copy">Click to copy</span>';
  clickToCopySpan.classList.add('tooltip__wrapper');
  clickToCopySpan.innerHTML = html;
  emailCopyMobile?.appendChild(clickToCopySpan);
  emailCopyMobile?.addEventListener('click', (e) => clickToCopy(e, emailCopyMobile));
}